<app-loading-bar></app-loading-bar>
@if (loaded) {
  <div>
    <app-nav></app-nav>
    <div class="container-fluid main-container">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
}
